/**
 * @generated SignedSource<<cfd0e9b624a868726dc77549160519da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItem_navItem$data = {
  readonly dataTn: string | null;
  readonly eventName: string | null;
  readonly exactLocation: boolean | null;
  readonly href: string | null;
  readonly items?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"NavDropdownItem_navItem">;
  } | null> | null;
  readonly newWindow: boolean | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "NavItem_navItem";
};
export type NavItem_navItem$key = {
  readonly " $data"?: NavItem_navItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_navItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItem_navItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newWindow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exactLocation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventName",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavBarListItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavDropdownItem_navItem"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "NavBarList",
      "abstractKey": null
    }
  ],
  "type": "NavBarElement",
  "abstractKey": "__isNavBarElement"
};

(node as any).hash = "a4ac38201751c8c10915d08f887907a6";

export default node;
